var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ path: '/'+_vm.link }}},[_c('div',{staticClass:"caption round-medium shadow-huge card left-text",style:(_vm.backgroundImg)},[_c('img',{staticClass:"caption-image owl-lazy",attrs:{"src":'images/mpower-new/'+_vm.image}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }